import {KEYS_QUERYS, TYPE_REQUEST, URL_PRODUCTION} from "../Const";
import axios from "axios";

import CryptoJs from "crypto-js";

export async function promiseServer(nameFile = null, params = null) {
      let dataUser = localStorage.getItem(KEYS_QUERYS.user);
      let url_link = `${URL_PRODUCTION}${nameFile}.php?`;


      if(!!dataUser){
            url_link = `${url_link}id_usuario=${dataUser.id_usuario}&contrasena=${decryptText(dataUser.token)}`
            url_link = !params? url_link:`${url_link}&`
      }

      if (!!params) {
            for (const [llave, valor] of Object.entries(params)) {
                  url_link = url_link.concat(`${llave}=${valor}&`);
            }
      }
      url_link = url_link.slice(0, -1);
      // console.log("url →", url_link);
      return new Promise((res, rej) => {
            fetch(url_link)
                .then(response => response.json())
                .then(data => res(data))
                .catch(error => rej(error));
      });

      // return await fetch(url_link)

}
// if(!nameFile && !params){
//       console.error("Error");
//       return;
// }
//
// let all_url = `${URL_PATH}${nameFile}.php?`;
//
// if(user && pwd){
//       all_url = `${all_url}${KEYS_QUERYS.pwd}=${pwd}&${KEYS_QUERYS.user}=${user}&`
// }
//
// if(!!params){
//       for (const thing of params) {
//             for (const [llave, valor] of Object.entries(thing)) {
//                   all_url = all_url.concat(`${llave}=${valor}&`);
//             }
//           }
// }
//
// all_url = all_url.slice(0, -1)
// try {
//
//       return new Promise((res, rej)=>{
//             fetch(all_url)
//                   .then(response => response.json())
//                   .then(data => res(data) )
//                   .catch(error => rej(error));
//       })
// } catch (error) {
//       console.error(error);
// }

export const requestSer = async (url = null, params = null, type = null, headers={}) => {
      let headersDefault = {...headers};
      let dataUser =  localStorage.getItem(KEYS_QUERYS.user)

      if(!!dataUser){
            headersDefault = {
                  ...headersDefault,
                  Authorization: `Token ${dataUser.token}`,
            }
      }

      let res = null
      switch (type) {
            case TYPE_REQUEST.GET:
                  res = await axios.get(url, params,headersDefault)
                  return res;
            case TYPE_REQUEST.POST:
                  res = await axios.post(url, params,headersDefault);

                  return res;
            default:
                  return;

      }
}

const secret = "+{}awda%$$%)%Gef"
export const encryptText = (text) => {
      const ciphertext = CryptoJs.AES.encrypt(text, secret).toString();
      return ciphertext;
};

export const decryptText = (ciphertext) => {
      const bytes = CryptoJs.AES.decrypt(ciphertext, secret);
      const originalText = bytes.toString(CryptoJs.enc.Utf8);
      return originalText;
};